<div [class]="state + '-content'">
  @if(state === 'success'){
  <div class="success-icon-container">
    <div class="main-success-circle">
      <img [src]="iconPath" alt="success-icon">
    </div>
    <div class="confetti-circle circle-1"></div>
    <div class="confetti-circle circle-2"></div>
    <div class="confetti-circle circle-3"></div>
    <div class="confetti-circle circle-4"></div>
    <div class="confetti-circle circle-5"></div>
  </div>
  }

  @if(state !== 'success'){
  <div [class]="state + '-icon-container'">
    <div [class]="'main-' + state + '-circle'">
      <img [src]="iconPath" [alt]="state + '-icon'">
    </div>
  </div>
  }

  <div [class]="state + '-message'">
    <h1 [class]="state + '-title'">{{ titleKey | translate }}</h1>
    <p [class]="state + '-description'">
      {{ descriptionKey | translate: (state === 'success' ? successDescriptionParams : {}) }}
    </p>
  </div>

  <div class="action-container">
    @for(action of actions; track action.labelKey){
    <button
      [class]="action.cssClass || 'btn btn-primary home-button'"
      (click)="action.onClick()">
      {{ action.labelKey | translate }}
    </button>
    }
  </div>
</div>
